var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPengaturan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M15.52 9.753l-1.47-1.15c.019-.177.035-.384.035-.604 0-.219-.016-.426-.035-.604l1.472-1.15c.274-.216.348-.6.174-.919l-1.53-2.646c-.162-.299-.52-.452-.884-.318l-1.735.697c-.333-.24-.681-.443-1.042-.605L10.24.614C10.198.263 9.894 0 9.534 0H6.468c-.36 0-.663.264-.706.608l-.264 1.847c-.35.158-.693.358-1.04.605l-1.74-.699c-.326-.126-.716.016-.878.313L.308 5.324c-.18.305-.106.701.174.923l1.47 1.15c-.023.224-.034.42-.034.603s.01.379.034.604L.48 9.754c-.273.217-.347.6-.173.92l1.53 2.645c.163.298.517.453.884.318l1.735-.696c.332.239.68.442 1.042.604l.264 1.84c.043.351.346.615.706.615h3.067c.36 0 .663-.264.706-.608l.264-1.847c.35-.158.692-.357 1.04-.605l1.74.699c.085.032.172.049.262.049.258 0 .496-.141.617-.361l1.536-2.66c.17-.312.096-.696-.18-.914zM8 10.667C6.53 10.667 5.335 9.47 5.335 8c0-1.47 1.196-2.667 2.667-2.667 1.47 0 2.667 1.196 2.667 2.667 0 1.47-1.196 2.667-2.667 2.667z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPengaturan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_pengaturan.55df2612.svg";
export { ForwardRef as ReactComponent };